import { ref } from 'vue'
import { db } from '@/plugins/firebase'
import { collection, query, getDocs, where, doc, getDoc } from 'firebase/firestore'
import { useGeneralHelpers } from '../helpers/useGeneralHelpers'
import { log } from '@/plugins/logger'

import { useAuthStore } from '@/store/auth'

export function useFirestoreUsers() {
  const users = ref({})
  const user = ref(null)
  const loadingUsers = ref(false)
  const loadingUser = ref(false)
  const usersCollectionRef = collection(db, `users`)
  const authStore = useAuthStore()
  const errorGettingUsers = ref(false)
  const { createBatches } = useGeneralHelpers()

  async function getUsersByIds(userIdList) {
    // given list of users, return user objects keyed by the user IDs
    loadingUsers.value = true
    errorGettingUsers.value = false
    try {
      const batches = createBatches(userIdList, 30)
      await Promise.all(
        batches.map(async batch => {
          const q = query(usersCollectionRef, where('uid', 'in', batch))
          const querySnapshot = await getDocs(q)
          querySnapshot.forEach(doc => {
            users.value[doc.id] = doc.data()
          })
        })
      )
    } catch (error) {
      log.error('Error fetching users', error)
      errorGettingUsers.value = true
    } finally {
      loadingUsers.value = false
    }
  }

  async function getAllTenantUsers() {
    loadingUsers.value = true
    errorGettingUsers.value = false

    try {
      const tempMap = {}
      const tenantId = authStore.userData.company
      const q = query(usersCollectionRef, where('company', '==', tenantId))
      const querySnapshot = await getDocs(q)
      querySnapshot.forEach(doc => {
        tempMap[doc.id] = doc.data()
      })
      users.value = tempMap
    } catch (error) {
      log.error('Error fetching users', error)
      errorGettingUsers.value = true
    } finally {
      loadingUsers.value = false
    }
  }

  async function getSingleUser(userId) {
    let docRef = doc(db, 'users', userId)
    loadingUser.value = true

    try {
      let userDoc = await getDoc(docRef)
      if (userDoc.exists()) {
        user.value = userDoc.data()
      } else {
        log.debug('No such document!')
      }
    } catch (error) {
      log.error('Error fetching user', error)
    } finally {
      loadingUser.value = false
    }
  }

  return {
    users,
    loadingUsers,
    getUsersByIds,
    user,
    loadingUser,
    getSingleUser,
    getAllTenantUsers,
    errorGettingUsers
  }
}
